/** Cell text that empties a supported value when updating an existing student. */
export const STUDENT_CSV_CLEAR = 'clear';

export const STUDENT_CSV_SCHEDULE_PAIR_ERROR =
  'Schedule and Class time must be provided together, cleared together, or left blank together.';

/** `clear` has nothing to empty when the student does not exist yet. */
export const STUDENT_CSV_CLEAR_ON_CREATE_ERROR = 'clear is only allowed when updating an existing student.';

/** A student CSV cell: blank keeps the current value, `clear` empties it, and a value replaces it. */
export type StudentCsvCell<T> = { kind: 'blank' } | { kind: 'clear' } | { kind: 'value'; value: T };

export function studentCsvCellFrom(raw: unknown): StudentCsvCell<string> {
  const trimmed = typeof raw === 'string' ? raw.trim() : '';
  if (trimmed === '') return { kind: 'blank' };
  if (trimmed.toLowerCase() === STUDENT_CSV_CLEAR) return { kind: 'clear' };
  return { kind: 'value', value: trimmed };
}

/** Update value for Prisma: `undefined` keeps the current value and `null` empties it. */
export function studentCsvCellUpdate<T>(cell: StudentCsvCell<T>): T | null | undefined {
  if (cell.kind === 'blank') return undefined;
  if (cell.kind === 'clear') return null;
  return cell.value;
}

/** Value for new students and identifiers, where blank and `clear` both mean no value. */
export function studentCsvCellValue<T>(cell: StudentCsvCell<T>): T | null {
  return cell.kind === 'value' ? cell.value : null;
}

/** Schedule and Class time must both be blank, both be `clear`, or both have values. */
export function studentCsvSchedulePairError(
  schedule: StudentCsvCell<string>,
  classTime: StudentCsvCell<string>,
): string | null {
  return schedule.kind === classTime.kind ? null : STUDENT_CSV_SCHEDULE_PAIR_ERROR;
}
